export default {
  data() {
    return {
      days: [
        this.$t('week_days.mon'),
        this.$t('week_days.thue'),
        this.$t('week_days.wed'),
        this.$t('week_days.thur'),
        this.$t('week_days.fri'),
        this.$t('week_days.sat'),
        this.$t('week_days.sun')
      ]
    }
  }
}
